package ai.jessie.web.invoices

import ai.jessie.shared.invoices.InvoiceLineResponse

// Display only: every amount, rate and quantity is the server's exact decimal string.
internal fun money(currency: String, amount: String) = "$currency ${groupedAmount(amount)}"

// Display only (decision 18 October 2026): apostrophes group the integer part of a money amount;
// sign, digits and decimals stay exactly as the server returned them.
internal fun groupedAmount(value: String): String {
    val sign = if (value.startsWith("-")) "-" else ""
    val integer = value.removePrefix(sign).substringBefore('.')
    if (integer.length <= GROUP_SIZE || !integer.all { it.isDigit() }) return value
    val grouped = integer.reversed().chunked(GROUP_SIZE).joinToString("’").reversed()
    return sign + grouped + value.removePrefix(sign).substring(integer.length)
}

private const val GROUP_SIZE = 3

internal fun lineTypeLabel(type: String) =
    when (type) {
        FREE -> "Freie Position"
        FIXED_PRICE -> "Fixpreis-Position"
        TIME_MATERIAL -> "Aufwandsposition"
        else -> "Position"
    }

internal fun invoiceStatusLabel(status: String) =
    when (status) {
        "DRAFT" -> "Entwurf"
        "READY" -> "Bereit"
        "SENT" -> "Versendet"
        "PAID" -> "Bezahlt"
        "CANCELLED" -> "Storniert"
        else -> "Unbekannter Status"
    }

// Step 8: the calculated quantity with its unit; billed minutes are the server's per-entry values.
internal fun quantityLabel(line: InvoiceLineResponse, currency: String) =
    when (line.type) {
        TIME_MATERIAL ->
            "${line.quantity} Std. (${line.work.sumOf { it.billedMinutes }} Min.) à " +
                "${money(currency, line.unitPrice)} pro Stunde"
        FIXED_PRICE -> "Fixpreis ${money(currency, line.unitPrice)}"
        else -> "${line.quantity} × ${money(currency, line.unitPrice)}"
    }

internal fun vatLabel(name: String, rate: String) = "$name $rate %"

internal fun addressLines(address: String) = address.split('\n').filter { it.isNotBlank() }
